import { ContractInfo, getRequestContractsInfoEndpoint } from 'cpie-common';
import { getSimpleDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<ContractInfo[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'request',
    fetchCallback() {
        return CpDataApi.get(getRequestContractsInfoEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchRequest = fetchData;
